import logo from '../../../LogoDA.png';
import { Box, Button, Toolbar, Paper, Container, useMediaQuery, Drawer, IconButton, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import {openInfoGuide} from '../../../Enhancers/useAnalytics';

export default function Navbar() {

  return (
    <Container style={{ 'position': 'fixed', 'display': 'contents' }}>
      <header className="Header">
        <Toolbar >
          <CenteredTabs />
        </Toolbar>
      </header>
    </Container>
  )
}

function CenteredTabs() {
  const useStyles = makeStyles((theme)=> ({
    root: {
      flexGrow: 1,
      minHeight: 105,
      boxShadow: "0px 4px 30px #FBEAFF",
    },
  }));

  const removingHyperLinks = makeStyles((theme)=> ({
    root: {
      textDecoration: 'none',
      color: '#838383',
      margin: 32,
      "@media (max-width: 576px)": {
        margin: 6,
      },
      "@media (max-width: 720px)": {
        margin: 9,
      },
      "@media (max-width: 1150px)": {
        margin: 12,
      },
      "@media (max-width: 1300px)": {
        margin: 20,
      },
    }
  }));

  const movingBoxDown = makeStyles((theme)=> ({
    root: {
      alignItems: 'center',
      marginTop: 4
    }
  }));

  const classes = useStyles();
  const classesLink = removingHyperLinks();
  const classesBox = movingBoxDown();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openDrawer, setOpenDrawer] = useState(false)

  const handleLinkClick = () => {
    openInfoGuide()
  }

  return (
    <Paper className={classes.root}>
      <Box style={{ padding: '20px' }} display="flex">
        <Box flexDirection="row" flexGrow={1}>
          <img style={{ height: 'fitContent', width: '120px' }} src={logo} alt="logo" /> 
        </Box>
        {isMobile ? 
        <>
        <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
          <MenuIcon/>
        </IconButton>
        <Drawer open={openDrawer} 
        onClose={() => setOpenDrawer(false)}>
          <a href="#ods" className={classesLink.root}>ODS ONU</a>
          <a onClick={()=> handleLinkClick()} href="https://sites.google.com/view/meuguiadireitoagil" target='blank' className={classesLink.root}>Guia Informativo Direito Ágil</a>
          <a href="#values" className={classesLink.root}>Metodologia Própria</a>
          <a href="#cases" className={classesLink.root}>Cases</a>
          <a href="#aboutUs" className={classesLink.root}>Publicações</a>
          <a href="#aboutUs" className={classesLink.root}>Sobre Nós</a>
          <a href="#contact" className={classesLink.root}>
            <Button variant="contained" style={{ backgroundColor: '#E65E8D', color: "#ffffff", height: "60px", width: '180px' }}>
              Contate-nos
            </Button>
          </a>
        </Drawer>
        </>
        :
        <Box className={classesBox.root}>
          <a href="#ods" className={classesLink.root}>ODS ONU</a>
          <a onClick={()=> handleLinkClick()} href="https://sites.google.com/view/meuguiadireitoagil" target='blank' className={classesLink.root}>Guia Informativo Direito Ágil</a>
          <a href="#values" className={classesLink.root}>Metodologia Própria</a>
          <a href="#cases" className={classesLink.root}>Cases</a>
          <a href="#aboutUs" className={classesLink.root}>Publicações</a>
          <a href="#aboutUs" className={classesLink.root}>Sobre Nós</a>
          <a href="#contact" className={classesLink.root}>
            <Button variant="contained" style={{ backgroundColor: '#E65E8D', color: "#ffffff", height: "60px", width: '180px' }}>
              Contate-nos
            </Button>
          </a>
        </Box>
        }
      </Box>
    </Paper>
  );
}
